import axios from "axios";

const url = process.env.REACT_APP_API_URL_PNBP
const urlSimponi = process.env.REACT_APP_API_URL_SIMPONI
const contentType = "application/json"

export default class BillingService {
    listBillingHeader(kdUpt, noBill, nmWjbByr, page, size) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        let param = ''
        if (kdUpt !== null) {
            param += '&kdUpt=' + kdUpt
        }
        if (noBill !== null) {
            param += '&noBill=' + noBill
        }
        if (nmWjbByr !== null) {
            param += '&nmWjbByr=' + nmWjbByr
        }
        return axios.get(url + '/billing-header?page=' + page + '&size=' + size + param + '&sort=dateBill,desc', {
            headers: {
                'Authorization': Auth
            }
        })
    }

    listBillingDetailByIdTrxUpt(idTrxUpt) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.get(url + '/billing-detail/' + idTrxUpt, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    listPayment(noBill) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.get(url + '/billing-payment/' + noBill, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    getBankById(id) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.get(url + '/bank/' + id, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    getChannelById(id) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.get(url + '/channel/' + id, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    getSatkerByKdUpt(id) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.get(url + '/satker/' + id, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    //simponi
    createBilling(jsonData) {
        return axios.post(urlSimponi + '/api_create_billing.php', jsonData, {
            headers: {
                'Content-Type': contentType
            }
        })
    }

    createBillingManual(jsonData) {
        return axios.post(urlSimponi + '/api_req_billing.php', jsonData, {
            headers: {
                'Content-Type': contentType
            }
        })
    }

    getPayment(jsonData) {
        return axios.post(urlSimponi + '/api_get_payment.php', jsonData, {
            headers: {
                'Content-Type': contentType
            }
        })
    }

    cetakBill(nobill) {
        return axios.get(urlSimponi + '/cetak_bill.php?bill=' + nobill, {
            responseType: "blob"
        })
    }
}